import React, { Fragment, useState, useEffect } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { useDispatch, useSelector } from "react-redux";
import { bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import { actions as adheredServicesActions } from "reducers/adheredServices";
import gaEventTracker, { events } from "util/gaEventTracker";
// import SideBar from "pages/discounts/_components/SideBar";
import Drawer from "pages/_components/Drawer/Drawer";
import TitleColumns from "./components/TitleColumns";
import AdheredServicesItem from "./components/ItemRow";

const AdheredServices = ({ isDesktop }) => {
    // const [openSidebar, setOpenSidebar] = useState(false);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { adheredServicesList, fetching } = useSelector((state) => state.adheredServices);
    const dispatch = useDispatch();
    const row = isDesktop ? 1 : 4;

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };
    useEffect(() => {
        gaEventTracker.triggerEvent(events.pagos_servicios_adheridos());
        dispatch(adheredServicesActions.adheredServicesListReducer());
    }, []);

    return (
        <Fragment>
            <Notification scopeToShow="adheredServices.list" />
            <ResponsiveHeader id="payments.service.supported" />
            <MainContainer>
                <ProductList
                    fetchingWithPreviousData
                    fetching={fetching}
                    items={adheredServicesList?.rapipagoServiceList || []}
                    noDataText="global.no.results"
                    noFiltersDataText="adheredServices.no.data"
                    renderItem={(item) => (
                        <GridTable.Container
                            key={`payments-item-${item.paymentModeId}`}
                            // renderAs={Link}
                            // to={`/debin/recived/detail/${item.paymentModeId}`}
                            columns={!isDesktop && 2}
                            columnsTemplate={isDesktop && "repeat(3, 1fr) 40px"}
                            className={!isDesktop && "box box-shadow"}>
                            <AdheredServicesItem
                                key={`transaction-${item.paymentModeId}`}
                                receivedAdheredService={item}
                                setDrawer={setActionDrawer}
                                isDesktop={isDesktop}
                            />
                        </GridTable.Container>
                    )}>
                    {(listItem) => (
                        <GridTable>
                            {isDesktop && (
                                <GridTable.Header>
                                    <GridTable.Container rows={row} columnsTemplate="repeat(3, 1fr) 40px">
                                        <TitleColumns />
                                    </GridTable.Container>
                                </GridTable.Header>
                            )}
                            <GridTable.Body>{listItem}</GridTable.Body>
                        </GridTable>
                    )}
                </ProductList>
                {/* <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                    <EmitedSideBarForm closeSidebar={setOpenSidebar} isReceived />
                </Drawer> */}
                <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                    {actionDrawer.contentDrawer}
                </Drawer>
                {/* <SideBar
                    openSidebar={actionDrawer.showDrawer}
                    onClose={handleCloseActionDrawer}
                    isDesktop={isDesktop}
                    title="">
                    {actionDrawer.contentDrawer}
                </SideBar> */}
            </MainContainer>
        </Fragment>
    );
};

AdheredServices.propTypes = {
    isDesktop: bool.isRequired,
};
export default AdheredServices;
